<template>
  <div class="row">
    <div class="col-sm-14 col-md-6 col-lg-4 text-start" v-for="item in ribbon" :key="item">
      <div class="ribbon-wrapper card">
        <div class="card-body">
          <div class="ribbon " :class="item.class">Ribbon</div>
          <p>{{ item.lorn }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-14 col-md-6 col-lg-4 text-start" v-for="item in vertical" :key="item">
      <div class="card" :class="item.card">
        <div class="card-body">
          <div class="ribbon" :class="item.class"><i :class="item.icon"></i></div>
          <p>{{ item.lorn }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-14 col-md-6 col-lg-4 text-start" v-for="item in bookmark" :key="item">
      <div class="ribbon-wrapper card">
        <div class="card-body">
          <div class="ribbon " :class="item.class">Ribbon</div>
          <p>{{ item.lorn }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-14 col-md-6 col-lg-4 text-start" v-for="item in verticalright" :key="item">
      <div class=" card" :class="item.card">
        <div class="card-body">
          <div class="ribbon " :class="item.class"><i :class="item.icon"></i></div>
          <p>{{ item.lorn }}</p>
        </div>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-sm-14 col-md-6 col-lg-4 text-start" v-for="item in  clip" :key="item">
      <div class=" card" :class="item.card">
        <div class="card-body">
          <div class="ribbon " :class="item.class">Ribbon</div>
          <p>{{ item.lorn }}</p>
        </div>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-sm-14 col-md-6 col-lg-4 text-start" v-for="item in ribbonItem" :key="item">
      <div class=" card" :class="item.card">
        <div class="card-body">
          <div class="ribbon " :class="item.class">Ribbon</div>
          <p>{{ item.lorn }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import data from "@/data/ribbons.json"
export default {
  data() {
    return {
      ribbon: data.right,
      vertical: data.verticalleft,
      bookmark: data.bookmark,
      verticalright: data.verticalright,
      clip: data.clip,
      ribbonItem: data.ribbon
    }
  }
}
</script>